<template>
  <p>Error 404: no page found at this address.</p>
</template>
<script setup lang="ts">
</script>
<style scoped>
</style>
